import currentUserDetailsReducersMapObject from '@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer';
import getWorkspaceReducersMapObject from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks';
import UserAccessReducersMapObject from '@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer';
import RouteUpdateReducer from '@ane/core/lib/services/syncUrlAndStore/RouteUpdateReducer';
/**
 * MAUI
 */
import { MauiReducer } from './views/MauiReducer';
import { LoadSubscribersReducersMapObject, SetSubscribersReducersMapObject, } from '@ane/exp-ux/lib/components/Subscribers';
import LoadSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks';
import SetSubscribersReducersMapObjectV2 from '@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks';
/**
 * Create an object that can simply be merged with the exp-ui reducer { ...reducers, ...analysisReducer }
 * this will map to state.analysis[branch]
 */
//: ReducersMapObject<IModuleState, any>
export const moduleReducer = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, currentUserDetailsReducersMapObject), RouteUpdateReducer), getWorkspaceReducersMapObject), UserAccessReducersMapObject), LoadSubscribersReducersMapObject), SetSubscribersReducersMapObject), LoadSubscribersReducersMapObjectV2), SetSubscribersReducersMapObjectV2), { maui: MauiReducer });

//# sourceMappingURL=reducers.js.map
